import {
  ChannelTypes,
  EventCategories,
  ISubscription,
  IEventChannel,
} from 'redux/reducers/subscriptions';
import cloneDeep from 'lodash.clonedeep';

type THandleChecked = (
  channel: ChannelTypes,
  category: EventCategories,
  subscription: ISubscription,
  isEditingMode?: boolean
) => void | ISubscription;

const removeOption: THandleChecked = (
  channel,
  category,
  subscription,
  isEditingMode
) => {
  const newState = { ...subscription };

  const existingChannel = newState.eventChannels.find(
    (chan: IEventChannel): boolean => {
      return (
        chan.channelId === channel &&
        chan.eventCategories.indexOf(category) > -1
      );
    }
  );

  if (existingChannel) {
    if (
      category === 'priority' &&
      (channel as ChannelTypes | 'all') !== 'all' &&
      isEditingMode
    ) {
      const channels = cloneDeep(newState.eventChannels);
      const newChannels = channels.reduce((prev: any, current: any) => {
        if (current.channelId === channel) {
          const eventCategories = current.eventCategories.filter(
            (category: any) => category !== 'priority'
          );
          return [
            ...prev,
            ...(eventCategories.length === 0
              ? []
              : [{ channelId: current.channelId, eventCategories }]),
          ];
        } else {
          return [...prev, current];
        }
      }, []);
      newState.eventChannels = newChannels;
    } else {
      let index = existingChannel.eventCategories.indexOf(category);
      existingChannel.eventCategories.splice(index, 1);
      if (existingChannel.eventCategories.length === 0) {
        index = newState.eventChannels.indexOf(existingChannel);
        newState.eventChannels.splice(index, 1);
      }
    }
  }
  return newState;
};

const addOption: THandleChecked = (channel, category, subscription) => {
  const newState = { ...subscription };

  const existingChannel = newState.eventChannels.find(
    (chan: IEventChannel): boolean => {
      return chan.channelId === channel;
    }
  );

  if (!existingChannel) {
    newState.eventChannels.push({
      channelId: channel,
      eventCategories: [category],
      ...(category === 'priority'
        ? { eventTypes: ['priority_playlist_add', 'priority_playlist_removal'] }
        : {}),
    });
  } else {
    if (existingChannel.eventCategories.indexOf(category) < 0) {
      existingChannel.eventCategories.push(category);
      if (category === 'priority') {
        existingChannel.eventTypes = [
          'priority_playlist_add',
          'priority_playlist_removal',
        ];
      }
    }
  }

  return newState;
};

export { removeOption, addOption };
